<template lang="html">
  <v-container style="margin-top: 1em;">

    <h2> POLITIQUE DE CONFIDENTIALITÉ </h2> <br> <br>

  Betadigitis s'engage à maintenir votre confiance en ce qui concerne la confidentialité des informations personnelles que nous recueillons de vous. <br> <br> Veuillez lire attentivement cette politique de confidentialité pour comprendre nos pratiques en matière de collecte, d'utilisation et de partage de vos informations personnelles.

  <br> <br> <strong> À propos de notre politique de confidentialité </strong> <br>

  Cette politique de confidentialité décrit comment les informations personnelles collectées lors de l'utilisation de l'application Betadigitis seront utilisées par BetaDigitis.

  <br> <br> <strong> Informations collectées </strong> <br>

  Le service collecte des informations auprès de vous de deux manières: directement à partir de votre saisie et automatiquement via les technologies du service.

  <br> <br> <strong> Informations que vous fournissez </strong> <br>

  Les types d'informations personnelles que le Service collecte directement auprès de vous peuvent inclure:
  <ul>
   <li> vos coordonnées, telles que votre nom, votre adresse électronique, votre adresse postale et votre numéro de téléphone; </li>
   <li> Noms d'utilisateur et mots de passe. </li>
  </ul>
  <br> Afin d'accéder à certains contenus et d'utiliser des fonctionnalités et fonctionnalités supplémentaires du Service, nous vous demandons de vous inscrire pour un compte en complétant et en soumettant un formulaire d'inscription, qui peut demander des informations supplémentaires.

  <br> <br> Si vous choisissez de vous inscrire et de vous connecter à l'aide d'un compte tiers (tel que votre compte Facebook), l'authentification de votre connexion est gérée par le tiers et le service collecte votre nom, votre adresse e-mail et toute autre information concernant votre compte tiers que vous acceptez de partager avec nous au moment où vous donnez l'autorisation de lier votre compte au Service à votre compte tiers.

  <br> <br> <strong> Informations collectées automatiquement </strong> <br>

  Le service collecte également automatiquement, via nos applications et d'autres technologies, des informations nous indiquant comment vous utilisez le service, telles que:
  <ul>
   <li> adresse de protocole Internet ("IP") utilisée pour connecter votre ordinateur à Internet; </li>
   <li> localisation GPS; </li>
   <li> Informations sur le périphérique et la connexion, telles que le type et la version du navigateur, le système d'exploitation, la plate-forme mobile et l'identificateur unique de périphérique ("UDID"), ainsi que d'autres identificateurs techniques; </li>
   <li> Uniform Resource Locator ("URL"), cliquez sur les données de flux, y compris l'horodatage, les URL de renvoi et de sortie, les termes de recherche que vous avez utilisés et les pages que vous avez visitées ou recherchées sur le service; et </li>
   <li> Pour les services de localisation, l'emplacement physique de votre appareil afin de vous fournir un contenu plus pertinent, quel que soit l'endroit où vous vous trouvez dans le monde. </li>
  </ul>
  <br> <br> Nous pouvons utiliser et divulguer des informations qui ne révèlent pas votre identité ni permettre une association directe avec une personne spécifique, telles que des informations sur le navigateur et le terminal, des données d'utilisation anonymes et des informations agrégées, à quelque fin que ce soit, sauf dans les cas où nous sommes restreints par la loi. Si nous combinons des informations non personnelles avec des informations personnelles, les informations combinées seront traitées comme des informations personnelles aussi longtemps qu'elles resteront combinées.

  <br> <br> <strong> Utilisation de vos informations </strong> <br> Nous pouvons utiliser vos informations personnelles pour:
  <ul>
   <li> Identifiez et analysez les tendances d'utilisation, notamment à des fins de recherche, d'audit et de reporting; </li>
   <li> Vous informer des modifications ou mises à jour du service, de nos produits et services. </li>
  </ul>
  <br> <br> <strong> Vos choix et préférences de communication </strong> <br>


  Vous pouvez gérer vos préférences de communication lorsque vous vous inscrivez au Service, en mettant à jour vos préférences de compte, en utilisant le mécanisme de "désabonnement" ou de désabonnement ou tout autre moyen fourni dans les communications que vous recevez de notre part ou en nous contactant. Nous nous réservons le droit de vous informer des modifications ou mises à jour du service si nécessaire.

  <br> <br> <strong> Accès à et exactitude de vos informations </strong> <br>

  Le service peut autoriser les utilisateurs enregistrés à accéder aux informations de leur compte et à apporter des corrections ou des mises à jour lors de leur connexion, à tout moment. L'exactitude de ces informations n'engage que la responsabilité de l'utilisateur. Vous pouvez également demander l'accès à d'autres informations personnelles vous concernant qui pourraient être conservées dans le Service. Si vous demandez la désactivation de votre compte ou la suppression de vos informations personnelles, nous nous efforcerons de répondre à votre demande, mais certaines informations personnelles peuvent rester dans les copies de sauvegarde pendant un certain temps et être conservées si nécessaire à des fins commerciales légitimes ou pour respecter nos conditions générales. obligations légales.

  <br> <br> <strong> Sécurité des données </strong> <br>

  Betadigitis prend des précautions pour protéger vos informations personnelles contre la perte, le vol, l'utilisation abusive, l'accès non autorisé, la divulgation, la modification et la destruction par le recours à des mesures de sécurité administratives, physiques et techniques appropriées.

  <br> <br> <strong> Modifications de notre politique de confidentialité </strong> <br>
  Nous pouvons modifier cette politique de confidentialité de temps à autre. Toute modification sera publiée sur cette page avec une date de révision mise à jour.

  <br> <br> <strong> Contact </strong> <br>

    Si vous avez des questions, des commentaires ou des demandes concernant cette politique de confidentialité ou le traitement de vos informations, veuillez contacter: contact@betadigtis.com

    <br> <br> Cette politique de confidentialité a été mise à jour le 11 avril 2019.

</v-container>
</template>

<script>
export default {
  data() {
    return {
      icons: [
        'fab fa-facebook',
        'fab fa-twitter',
        'fab fa-linkedin'
      ]
    }
  }
}
</script>

<style lang="css" scoped>
</style>
